export function formatToYesNo(bool) {
    return (bool === true || bool === 'true') ? "Yes" : "No"
}